//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const UpdatePassword = createAsyncThunk(
  "UpdatePassword",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingUpdatePassword(""));
      const response = await UsePortalApi(
        `Patient/UpdatePassword`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
      dispatch(gettingUpdatePasswordSuccess(response)) 

      } else {
        dispatch(
          gettingUpdatePasswordFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingUpdatePasswordFailed(error));
    }
  }
);
const UpdatePasswordSlice = createSlice({
  name: "UpdatePassword",
  initialState: {
    UpdatePasswordData: null,
    isUpdatePasswordLoading: false,
    isUpdatePasswordError: false,
  },
  reducers: {
    gettingUpdatePassword: (state, action) => {
      state.UpdatePasswordData = null;
      state.isUpdatePasswordLoading = true;
      state.isUpdatePasswordError = false;
    },
    gettingUpdatePasswordSuccess: (state, action) => {
      state.UpdatePasswordData = action.payload;
      state.isUpdatePasswordLoading = false;
      state.isUpdatePasswordError = false;
    },
    gettingUpdatePasswordFailed: (state, action) => {
      state.UpdatePasswordData = null;
      state.isUpdatePasswordLoading = false;
      state.isUpdatePasswordError = true;
    },
    gettingUpdatePasswordClear: (state, action) => {
      state.UpdatePasswordData = null;
      state.isUpdatePasswordLoading = false;
      state.isUpdatePasswordError = false;
    },
  },
});
export const {
  gettingUpdatePassword,
  gettingUpdatePasswordSuccess,
  gettingUpdatePasswordFailed,
  gettingUpdatePasswordClear,
} = UpdatePasswordSlice.actions;
export default UpdatePasswordSlice.reducer;
